













import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'ProductDetailsAvailability',
  props: {
    availability: {
      type: String,
      require: true,
    },
  },
  computed: {
    translatedAvailability(): string {
      return `${this.availability}`
    },
  },
})
